<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.72 12.92C19.46 12.37 19.32 11.75 19.32 11.15V9.86998C19.32 5.78998 16 2.47998 11.93 2.47998C7.86001 2.47998 4.54001 5.78998 4.54001 9.86998V11.15C4.54001 11.76 4.40001 12.37 4.14001 12.92L3.68001 13.88C3.21001 14.88 3.28001 16.04 3.88001 16.98C4.47001 17.92 5.49001 18.48 6.60001 18.48H7.96001C8.21001 20.46 9.88001 22 11.93 22C13.98 22 15.65 20.46 15.9 18.48H17.26C18.37 18.48 19.39 17.92 19.98 16.99C20.57 16.05 20.65 14.89 20.18 13.89L19.73 12.93L19.72 12.92ZM11.93 20C10.99 20 10.21 19.35 9.98001 18.48H13.88C13.66 19.35 12.87 20 11.93 20ZM18.29 15.91C18.06 16.27 17.68 16.48 17.26 16.48H6.61001C6.18001 16.48 5.81001 16.27 5.58001 15.91C5.35001 15.55 5.32001 15.12 5.51001 14.73L5.96001 13.77C6.34001 12.96 6.55001 12.05 6.55001 11.15V9.86998C6.55001 6.89998 8.97001 4.47998 11.94 4.47998C14.91 4.47998 17.33 6.89998 17.33 9.86998V11.15C17.33 12.05 17.53 12.95 17.92 13.77L18.37 14.73C18.55 15.12 18.53 15.55 18.3 15.91H18.29Z"
      fill="currentColor"
    />
    <path
      d="M4.00001 6.77998C4.38001 6.77998 4.74001 6.55998 4.91001 6.19998C5.33001 5.27998 6.00001 4.44998 6.84001 3.78998C7.28001 3.44998 7.35001 2.81998 7.01001 2.38998C6.67001 1.94998 6.04001 1.87998 5.61001 2.21998C4.52001 3.05998 3.65001 4.14998 3.09001 5.35998C2.86001 5.85998 3.08001 6.45998 3.58001 6.68998C3.72001 6.74998 3.86001 6.77998 4.00001 6.77998Z"
      fill="currentColor"
    />
    <path
      d="M20.77 5.35998C20.21 4.14998 19.35 3.05998 18.26 2.20998C17.82 1.86998 17.2 1.94998 16.86 2.37998C16.52 2.81998 16.6 3.43998 17.03 3.77998C17.87 4.42998 18.53 5.25998 18.96 6.18998C19.13 6.55998 19.49 6.76998 19.87 6.76998C20.01 6.76998 20.15 6.73998 20.29 6.67998C20.79 6.44998 21.01 5.85998 20.78 5.34998L20.77 5.35998Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
